
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/ownership",
      function () {
        return require("private-next-pages/terms/ownership.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/ownership"])
      });
    }
  